import PropTypes from 'prop-types';
import { PAYWALL_ROW_ITEM_PROP_TYPES } from '../row-item/constants';

export const PAYWALL_GROUP_HEADER_PROP_TYPES = {
  groupTitle: PropTypes.string,
  availablePlans: PropTypes.arrayOf(PropTypes.string),
};

export const PAYWALL_BODY_PROP_TYPES = {
  highlightedElementId: PropTypes.string,
  isLoading: PropTypes.bool,
  onTooltipHover: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.shape({ ...PAYWALL_ROW_ITEM_PROP_TYPES, id: PropTypes.string.isRequired })
  ).isRequired,
  ...PAYWALL_GROUP_HEADER_PROP_TYPES,
};
